<template>
	<l-marker
		ref="marker"
		v-bind:lat-lng="fromGeoJson(offer.location__geo)"
		v-on:click="toggleActive"
	>
		<l-icon
			ref="icon"
			:icon-url="iconUrl"
			v-bind:popup-anchor="[0, -10]"
			v-bind:icon-size="isActive ? [28, 28] : [20, 20]"
		/>
		<l-popup ref="popup" class="font-sans text-base p-3">
			<div class="whitespace-nowrap flex space-x-2 items-baseline mr-8">
				<crop-product-summary-refactored
					class="font-medium text-gray-900"
					:tradable="offer"
				/>
				<!-- <div class="text-gray-500 text-xs pr-4">{{offer.trade == 'SELL' ? __('Seller') : __('Buyer') }}</div> -->
			</div>

			<div class="text-sm">{{ $cropOptions.dateToString(offer, locale) }}</div>


			<!-- Parität -->
			<div class="text-sm">

				<!--	Loadingspinner	-->
				<span v-if="user && item.dispatched">
					<ui-loading-spinner :size="3" />
				</span>

				<!--	Frei Fuhre			-->
				<span v-else-if="user && item.price_estimate">
					{{
						$cropOptions.getLocalizedLabel(
							"FCA",
							$cropOptions.locationModeOptions
						)
					}}
				</span>
				<!--	Franko		-->
				<span v-else>
					{{
						$cropOptions.getLocalizedLabel(
							offer.location__mode,
							$cropOptions.locationModeOptions
						)
					}}
				</span>
			</div>
			<!-- Parität Ende -->

			<div class="flex justify-between flex items-center font-semibold">
				<span>{{ offer.qty__mt }} t</span>
				<span v-if="acl.see_price">
					<span v-if="freightCostAdjusted() && item.price_estimate">
						{{
							item.price_estimate
								? $cropOptions.formatLocalizedNumber(item.price_estimate) +
								  " €/t"
								: __("n.a.")
						}}
					</span>
						<span v-else-if="freightCostAdjusted() && item.dispatched && !item.price_estimate"
									class="min-w-12 flex justify-center"
						>
						<ui-loading-spinner :size="3" />
					</span>
					<span v-else>
						{{
							offer.price__mt
								? $cropOptions.formatLocalizedNumber(offer.price__mt) + " €/t"
								: ""
						}}
					</span>
				</span>
			</div>
			<div class="flex">
				<button
					v-if="item.thread_id"
					type="primary"
					class="ml-auto text-sm mt-2"
					v-on:click="
						$inertia.visit($route('threads', { active_id: item.thread_id }))
					"
				>
					{{ __("Go to negotiation") }}
				</button>
				<ui-button
					v-else
					type="primary"
					class="ml-auto text-sm mt-2"
					v-on:click="maybeBid()"
					:label="
						item.offer.trade == 'BUY' ? 'Go to Buy Offer' : 'Go to Sell Offer'
					"
				/>
			</div>
		</l-popup>
	</l-marker>
</template>

<script>
// http://localhost:6103/images/leaflet-color-markers/img/map-pointer-green.svg
let options = require("../../cropOptions.js");
import {
	LMap,
	LTileLayer,
	LFeatureGroup,
	LMarker,
	LPopup,
	LIcon,
} from "vue2-leaflet";

export default {
	props: {
		item: {
			type: Object,
			required: true,
		},
		activeId: {
			type: String,
			required: false,
		},
		user: {
			type: Object,
			required: false,
		},
	},
	components: {
		LIcon,
		LMarker,
		LPopup,
	},
	computed: {
		iconUrl: function () {
			let trade = this.offer.trade.toLowerCase(),
				icon = [
					trade == "buy" ? "square-orange" : "circle-green",
					this.isActive ? ".active" : "",
					".svg",
				].join("");
			return window.baseUrl + "/images/leaflet-color-markers/img/" + icon;
		},
		isActive() {
			return this.activeId != null && this.activeId == this.item.match_id;
		},
	},
	data() {
		return {
			offer: this.item.offer,
			acl: this.$inertia.page.props.acl,
		};
	},
	methods: {
		fromGeoJson: function (geoJ) {
			return {
				lat: geoJ.coordinates[1],
				lng: geoJ.coordinates[0],
			};
		},
		iconBaseUrl: function () {
			return window.baseUrl + "/images/leaflet-color-markers/img/";
			// return "/images/leaflet-color-markers/img/";
		},
		toggleActive() {
			this.$root.$emit("new-active-marker-id", this.item.match_id);
			//this.iconUrl = this.iconBaseUrl() + 'map-pointer-orange.svg'
		},
		freightCostAdjusted() {
			let shouldBeAdjusted = false;

			if (
				this.user.type == "FARMER" &&
				this.offer.trade == "BUY" &&
				this.offer.location__mode == "DAP" &&
				this.offer.location__optional_transport
			) {
				shouldBeAdjusted = true;
			}

			return shouldBeAdjusted;
		},
		maybeBid() {
			if (this.acl.can_trade) {
				this.$bus.$emit(
					"toggle-iframe-modal",
					this.$route("bid.create", {
						targetType: this.offer.trade,
						targetId: this.offer.id,
					}),
					true,
					false
				);
			} else {
				this.$bus.$emit("toggle-permission-denied-modal");
			}
		},
	},
	watch: {
		activeId: function (newActiveId) {
			console.log("new active marker", newActiveId);
			if (newActiveId != this.item.match_id) {
				// popup should be closed
				this.$refs.marker.mapObject.closePopup();
				this.$refs.marker.mapObject.options.zIndexOffset = 0;
			} else {
				this.$refs.marker.mapObject.openPopup();
				this.$refs.marker.mapObject.options.zIndexOffset = 6100;
			}
		},
	},
};
</script>
